import { AbstractFormFragment } from '@components/form/AbstractFormFragment';

export class TextAreaFormFragment extends AbstractFormFragment {
  static getCssClassName(): string {
    return 'comp-form-textarea';
  }

  // NOTE: original returned the string value (truthy/falsy). Fixed to return boolean.
  hasValue(): boolean {
    return !!(this.node.querySelector<HTMLTextAreaElement>('textarea')?.value);
  }

  attachChangeListener(callback: () => void): this {
    this.node
      .querySelector<HTMLTextAreaElement>('textarea')
      ?.addEventListener('input', () => {
        this.triggerDelayed(callback);
      });
    return this;
  }
}

export default TextAreaFormFragment;
